export default "__VITE_PUBLIC_ASSET__77fb5a1b__"